import { type SearchResultsDTO, type SRPTreeViewNodeDTO } from "../../Search/dto/SearchResultsDTO";
import { resolveUrl } from "../../utils/url/urlResolver";

export const fetchNavigationSeriesTree = async (): Promise<SRPTreeViewNodeDTO[] | null> => {
  const response = await fetch(resolveUrl("/search/navigationTree"), {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });
  if (!response.ok) {
    return null;
  }
  const searchResults: SearchResultsDTO = await response.json();
  return searchResults.treeView;
};
